import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useCarrito } from '../context/CarritoContext';
import { useAuth } from '../context/AuthContext';

const CarritoDrawer = () => {
  const { items, eliminar, actualizar, total, totalItems, carritoAbierto, setCarritoAbierto } = useCarrito();
  const { cliente } = useAuth();
  const navigate = useNavigate();

  const handleCheckout = () => {
    setCarritoAbierto(false);
    if (!cliente) { navigate('/login'); return; }
    navigate('/checkout');
  };

  if (!carritoAbierto) return null;

  return (
    <>
      {/* Overlay oscuro */}
      <div
        className="fixed inset-0 bg-black/50 z-40 backdrop-blur-sm"
        onClick={() => setCarritoAbierto(false)}
      />

      {/* Drawer */}
      <div className="fixed top-0 right-0 h-full w-full max-w-md bg-white z-50 flex flex-col shadow-2xl">

        {/* Header */}
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-100">
          <div className="flex items-center gap-2">
            <h2 className="text-lg font-bold text-gray-800">Tu carrito</h2>
            {totalItems > 0 && (
              <span className="bg-red-600 text-white text-xs font-bold px-2 py-0.5 rounded-full">
                {totalItems}
              </span>
            )}
          </div>
          <button
            onClick={() => setCarritoAbierto(false)}
            className="text-gray-400 hover:text-gray-600 transition-colors p-1">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Items */}
        <div className="flex-1 overflow-y-auto px-5 py-4 space-y-4">
          {items.length === 0 ? (
            <div className="flex flex-col items-center justify-center h-full text-center">
              <div className="text-5xl mb-4">🛒</div>
              <p className="font-bold text-gray-700 mb-1">Tu carrito está vacío</p>
              <p className="text-gray-400 text-sm mb-6">Agrega productos para continuar</p>
              <button
                onClick={() => { setCarritoAbierto(false); navigate('/catalogo'); }}
                className="bg-red-700 text-white px-6 py-2.5 rounded-xl font-medium hover:bg-red-800 transition-colors text-sm">
                Ver catálogo
              </button>
            </div>
          ) : (
            items.map(item => (
              <div key={item.id} className="flex gap-3 bg-gray-50 rounded-xl p-3">
                <Link to={`/producto/${item.id}`} onClick={() => setCarritoAbierto(false)}>
                  <img
                    src={item.imagenUrl}
                    alt={item.nombre}
                    className="w-16 h-16 object-contain bg-white rounded-lg p-1 flex-shrink-0 hover:opacity-80 transition-opacity"
                  />
                </Link>
                <div className="flex-1 min-w-0">
                  <Link to={`/producto/${item.id}`} onClick={() => setCarritoAbierto(false)}>
                    <p className="text-sm font-medium text-gray-800 leading-tight line-clamp-2 hover:text-red-600 transition-colors">
                      {item.nombre}
                    </p>
                  </Link>
                  <p className="text-red-700 font-bold text-sm mt-1">
                    ${Number(item.precio).toLocaleString('es-CO')}
                  </p>
                  <div className="flex items-center justify-between mt-2">
                    <div className="flex items-center border border-gray-200 rounded-lg overflow-hidden bg-white">
                      <button onClick={() => actualizar(item.id, item.cantidad - 1)}
                        className="px-2 py-1 text-gray-600 hover:bg-gray-50 text-sm">−</button>
                      <span className="px-2 py-1 text-sm border-x border-gray-200">{item.cantidad}</span>
                      <button
                        onClick={() => actualizar(item.id, item.cantidad + 1)}
                        disabled={item.cantidad >= item.stock}
                        className="px-2 py-1 text-gray-600 hover:bg-gray-50 text-sm disabled:opacity-30">+</button>
                    </div>
                    <button onClick={() => eliminar(item.id)}
                      className="text-red-400 hover:text-red-600 text-xs">Eliminar</button>
                  </div>
                </div>
                <div className="text-right flex-shrink-0">
                  <p className="font-bold text-gray-800 text-sm">
                    ${(Number(item.precio) * item.cantidad).toLocaleString('es-CO')}
                  </p>
                </div>
              </div>
            ))
          )}
        </div>

        {/* Footer con total y acciones */}
        {items.length > 0 && (
          <div className="border-t border-gray-100 px-5 py-4 space-y-3">

            {total < 300000 && (
              <div className="bg-red-50 border border-red-100 rounded-xl px-3 py-2">
                <p className="text-xs text-red-700">
                  🎉 Agrega <strong>${(300000 - total).toLocaleString('es-CO')}</strong> más y obtén envío gratis
                </p>
              </div>
            )}

            <div className="flex justify-between font-bold text-gray-800">
              <span>Subtotal</span>
              <span>${total.toLocaleString('es-CO')}</span>
            </div>

            <button
              onClick={handleCheckout}
              className="w-full bg-red-700 text-white font-bold py-3 rounded-xl hover:bg-red-800 transition-colors">
              Proceder al pago
            </button>

            <Link
              to="/carrito"
              onClick={() => setCarritoAbierto(false)}
              className="block text-center text-sm text-gray-500 hover:text-red-700 transition-colors">
              Ver carrito completo
            </Link>
          </div>
        )}
      </div>
    </>
  );
};

export default CarritoDrawer;